
import React, { useState } from "react";
import { Row, Col, Form, Input, Button, Dropdown, Menu, Badge } from "antd";
import { DownOutlined } from "@ant-design/icons";

import { BreadcrumbAbrirChamado, TabelaDados } from "../../components";
import { FormatNumber } from "../../ValueObjects";

export default function RetornoBancarioLista() {

    const [ carregando, setCarregando ] = useState(false);

    function menu() {
        return (
            <Menu>
                <Menu.Item key="1">
                    Liquidada  <Badge count={5} size="small"/>
                </Menu.Item>
                <Menu.Item key="2">
                    Erros  <Badge count={1} size="small"/>
                </Menu.Item>
                <Menu.Item key="3">
                    Todos  <Badge count={2} size="small"/>
                </Menu.Item>
            </Menu>
        )
    }

    return (
        <div className="p-10">
            <BreadcrumbAbrirChamado />
            <div>
                <Form layout="vertical">
                    <Row gutter={[8, 0]}>
                        <Col xs={24} sm={24} md={16} lg={13} xl={14}>
                            <Form.Item label="Pesquisar por">
                                <Input.Search placeholder="Banco" allowClear/>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                            <Form.Item label="Motivo">
                                <Input placeholder="Informe Motivo" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={5} xl={4} className="t-5">
                            <Dropdown overlay={menu} trigger={['click']}>
                                <Button block className="t-mob-573 t15 t0">
                                    Tipos Retorno Bancário <DownOutlined />
                                </Button>
                            </Dropdown>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div className="tabela">
                <TabelaDados url="" colunas={
                    [
                        { 
                            title: 'Retorno Bancário',     
                            render: ({ctc_numeroconta, pes_nome}) => (
                                <div>
                                    <Row align="middle" gutter={[8, 0]}>
                                        <Col>
                                            <img className="imgLogoListaBanco" src={require('../../assets/logoBancos/banco-bradesco.png').default} alt="Banco Bradesco S.A"/>
                                        </Col>
                                        <Col>
                                            <b>{ctc_numeroconta}</b>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <b>{pes_nome}</b>
                                        </Col>
                                    </Row>
                                </div>
                            ),
                        },
                        { 
                            title: 'Motivo', 
                            render: ({bol_motivo}) => (
                                <div>
                                    <b>{bol_motivo}</b>
                                </div>
                            ),
                        },
                        { 
                            title: 'Valor (R$)', 
                            align: 'right',
                            fixed: 'right',
                            render: ({prc_valor}) => (
                                <div>
                                    <b>{FormatNumber(prc_valor, true)}</b>
                                </div>
                            ),
                        },
                    ]
                } expandir={({ ser_serie, bol_numero, prc_numeroparcela }) => {
                    return (
                        <div>
                            <Row align="middle" gutter={[8, 0]}>
                                <Col span={8}>
                                    Série: <b> {ser_serie}</b> 
                                </Col>
                                <Col span={8}>
                                    Nº Doc.: <b>{bol_numero}</b>  
                                </Col>
                                <Col span={8}>
                                    Parcela: <b> {prc_numeroparcela}</b> 
                                </Col>
                            </Row>
                        </div>
                    )
                }} /> 
            </div> 
        </div>
    );
    
}